import React from "react";
import styled from "styled-components";
import { ErrorMessage } from "@hookform/error-message";
import { MbjLabel } from "../MbjLabel/MbjLabel";
import { FieldErrors } from "react-hook-form";

interface MbjSimpleInputContainerCtrlProps {
  /**
   * Classe HTML du container ?
   */
  className?: string;

  direction?: "row" | "column";

  label?: string;
  /**
   * Input :
   */
  children: any;
  /**
   * htmlFor
   */
  htmlFor?: string;
  /**
   * Erreurs du formulaire :
   */
  errors: FieldErrors;
}

function MbjSimpleInputContainerCtrl(props: MbjSimpleInputContainerCtrlProps) {
  return (
    <div className={props.className}>
      {props.label ? (
        <div className={"label-input-container"}>
          <MbjLabel
            htmlFor={props.htmlFor ? props.htmlFor : props.children.props.id}
            size={"very-small"}
            themeColor={"primary"}
          >
            {props.label}
          </MbjLabel>
          {props.children}
        </div>
      ) : (
        props.children
      )}
      <ErrorMessage
        errors={props.errors}
        name={props.children.props.name}
        render={({ message }) => <p className="error-messages">{message}</p>}
      />
    </div>
  );
}

export const MbjSimpleInputContainer = styled(MbjSimpleInputContainerCtrl)((props) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  textAlign: "start",

  "& .label-input-container": {
    display: "flex",
    flexDirection: props.direction,
    alignItems: props.direction === "row" ? "center" : "stretch",
    gap: props.direction === "row" ? "12px" : "3px",
  },

  "p.error-messages": {
    textAlign: "start",
    color: "#bf1650",
    fontSize: "16px",
  },

  "& p.error-messages:before": {
    display: "inline",
    content: '"⚠ "',
  },

  "input, textarea": { width: "100%" },
}));
MbjSimpleInputContainer.defaultProps = {
  direction: "column",
};
